import { useDispatch, useSelector } from "react-redux";
export const SVGInformation = () => {
    const FetchCompanyDetails1 = useSelector(
        (state) => state.user.FetchCompanyDetails
    );
    return (
        <svg
            id="Group_2719"
            data-name="Group 2719"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 18.918 21.055"
        >
            <path
                id="Path_2062"
                data-name="Path 2062"
                d="M21.159,22.38a.908.908,0,0,1-.908-.908V19.334a3.371,3.371,0,0,0-3.367-3.367H8.334a3.371,3.371,0,0,0-3.367,3.367v2.138a.908.908,0,1,1-1.817,0V19.334A5.19,5.19,0,0,1,8.334,14.15h8.55a5.19,5.19,0,0,1,5.184,5.184v2.138A.908.908,0,0,1,21.159,22.38Z"
                transform="translate(-3.15 -1.324)"
                fill={FetchCompanyDetails1?.data[0]?.textcolor}
            />
            <path
                id="Ellipse_9"
                data-name="Ellipse 9"
                d="M4.334-.85A5.184,5.184,0,1,1-.85,4.334,5.19,5.19,0,0,1,4.334-.85Zm0,8.55A3.367,3.367,0,1,0,.967,4.334,3.371,3.371,0,0,0,4.334,7.7Z"
                transform="translate(5.125 0.85)"
                fill={FetchCompanyDetails1?.data[0]?.textcolor}
            />
        </svg>
    );
};
export const SVGMember2 = () => {
    const FetchCompanyDetails1 = useSelector(
        (state) => state.user.FetchCompanyDetails
    );
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24.062 20">
            <g
                id="Group_3056"
                data-name="Group 3056"
                transform="translate(-872 -7760.324)"
            >
                <path
                    id="Path_2059"
                    data-name="Path 2059"
                    d="M17.257,21.967a.863.863,0,0,1-.863-.863V19.074a3.2,3.2,0,0,0-3.2-3.2H5.074a3.2,3.2,0,0,0-3.2,3.2V21.1a.863.863,0,0,1-1.726,0V19.074A4.93,4.93,0,0,1,5.074,14.15H13.2a4.93,4.93,0,0,1,4.924,4.924V21.1A.863.863,0,0,1,17.257,21.967Z"
                    transform="translate(871.85 7758.356)"
                    fill="#95A7C6"
                />
                <path
                    id="Ellipse_8"
                    data-name="Ellipse 8"
                    d="M4.074-.85A4.924,4.924,0,1,1-.85,4.074,4.93,4.93,0,0,1,4.074-.85Zm0,8.122a3.2,3.2,0,1,0-3.2-3.2A3.2,3.2,0,0,0,4.074,7.272Z"
                    transform="translate(876.911 7761.174)"
                    fill={FetchCompanyDetails1?.data[0]?.textcolor}
                />
                <path
                    id="Path_2060"
                    data-name="Path 2060"
                    d="M23.059,21.965A.863.863,0,0,1,22.2,21.1V19.072a3.2,3.2,0,0,0-2.4-3.093.863.863,0,0,1,.431-1.671,4.924,4.924,0,0,1,3.693,4.764V21.1A.863.863,0,0,1,23.059,21.965Z"
                    transform="translate(872.14 7758.358)"
                    fill={FetchCompanyDetails1?.data[0]?.textcolor}
                />
                <path
                    id="Path_2061"
                    data-name="Path 2061"
                    d="M16.012,11.874a.863.863,0,0,1-.213-1.7,3.2,3.2,0,0,0,0-6.2.863.863,0,0,1,.428-1.672,4.924,4.924,0,0,1,0,9.54A.865.865,0,0,1,16.012,11.874Z"
                    transform="translate(872.079 7758.176)"
                    fill="#333"
                />
                <path
                    id="Path_2059-2"
                    data-name="Path 2059"
                    d="M17.257,21.967a.863.863,0,0,1-.863-.863V19.074a3.2,3.2,0,0,0-3.2-3.2H5.074a3.2,3.2,0,0,0-3.2,3.2V21.1a.863.863,0,0,1-1.726,0V19.074A4.93,4.93,0,0,1,5.074,14.15H13.2a4.93,4.93,0,0,1,4.924,4.924V21.1A.863.863,0,0,1,17.257,21.967Z"
                    transform="translate(871.85 7758.356)"
                    fill="#95A7C6"
                />
                <path
                    id="Ellipse_8-2"
                    data-name="Ellipse 8"
                    d="M4.074-.85A4.924,4.924,0,1,1-.85,4.074,4.93,4.93,0,0,1,4.074-.85Zm0,8.122a3.2,3.2,0,1,0-3.2-3.2A3.2,3.2,0,0,0,4.074,7.272Z"
                    transform="translate(876.911 7761.174)"
                    fill="#95A7C6"
                />
                <path
                    id="Path_2060-2"
                    data-name="Path 2060"
                    d="M23.059,21.965A.863.863,0,0,1,22.2,21.1V19.072a3.2,3.2,0,0,0-2.4-3.093.863.863,0,0,1,.431-1.671,4.924,4.924,0,0,1,3.693,4.764V21.1A.863.863,0,0,1,23.059,21.965Z"
                    transform="translate(872.14 7758.358)"
                    fill="#95A7C6"
                />
                <path
                    id="Path_2061-2"
                    data-name="Path 2061"
                    d="M16.012,11.874a.863.863,0,0,1-.213-1.7,3.2,3.2,0,0,0,0-6.2.863.863,0,0,1,.428-1.672,4.924,4.924,0,0,1,0,9.54A.865.865,0,0,1,16.012,11.874Z"
                    transform="translate(872.079 7758.176)"
                    fill="#95A7C6"
                />
            </g>
        </svg>
    );
};
export const SVGMember = () => {
    const FetchCompanyDetails1 = useSelector(
        (state) => state.user.FetchCompanyDetails
    );
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24.062 20">
            <g
                id="Group_3056"
                data-name="Group 3056"
                transform="translate(-872 -7760.324)"
            >
                <path
                    id="Path_2059"
                    data-name="Path 2059"
                    d="M17.257,21.967a.863.863,0,0,1-.863-.863V19.074a3.2,3.2,0,0,0-3.2-3.2H5.074a3.2,3.2,0,0,0-3.2,3.2V21.1a.863.863,0,0,1-1.726,0V19.074A4.93,4.93,0,0,1,5.074,14.15H13.2a4.93,4.93,0,0,1,4.924,4.924V21.1A.863.863,0,0,1,17.257,21.967Z"
                    transform="translate(871.85 7758.356)"
                    fill={FetchCompanyDetails1?.data[0]?.textcolor}
                />
                <path
                    id="Ellipse_8"
                    data-name="Ellipse 8"
                    d="M4.074-.85A4.924,4.924,0,1,1-.85,4.074,4.93,4.93,0,0,1,4.074-.85Zm0,8.122a3.2,3.2,0,1,0-3.2-3.2A3.2,3.2,0,0,0,4.074,7.272Z"
                    transform="translate(876.911 7761.174)"
                    fill={FetchCompanyDetails1?.data[0]?.textcolor}
                />
                <path
                    id="Path_2060"
                    data-name="Path 2060"
                    d="M23.059,21.965A.863.863,0,0,1,22.2,21.1V19.072a3.2,3.2,0,0,0-2.4-3.093.863.863,0,0,1,.431-1.671,4.924,4.924,0,0,1,3.693,4.764V21.1A.863.863,0,0,1,23.059,21.965Z"
                    transform="translate(872.14 7758.358)"
                    fill={FetchCompanyDetails1?.data[0]?.textcolor}
                />
                <path
                    id="Path_2061"
                    data-name="Path 2061"
                    d="M16.012,11.874a.863.863,0,0,1-.213-1.7,3.2,3.2,0,0,0,0-6.2.863.863,0,0,1,.428-1.672,4.924,4.924,0,0,1,0,9.54A.865.865,0,0,1,16.012,11.874Z"
                    transform="translate(872.079 7758.176)"
                    fill={FetchCompanyDetails1?.data[0]?.textcolor}
                />
                <path
                    id="Path_2059-2"
                    data-name="Path 2059"
                    d="M17.257,21.967a.863.863,0,0,1-.863-.863V19.074a3.2,3.2,0,0,0-3.2-3.2H5.074a3.2,3.2,0,0,0-3.2,3.2V21.1a.863.863,0,0,1-1.726,0V19.074A4.93,4.93,0,0,1,5.074,14.15H13.2a4.93,4.93,0,0,1,4.924,4.924V21.1A.863.863,0,0,1,17.257,21.967Z"
                    transform="translate(871.85 7758.356)"
                    fill={FetchCompanyDetails1?.data[0]?.textcolor}
                />
                <path
                    id="Ellipse_8-2"
                    data-name="Ellipse 8"
                    d="M4.074-.85A4.924,4.924,0,1,1-.85,4.074,4.93,4.93,0,0,1,4.074-.85Zm0,8.122a3.2,3.2,0,1,0-3.2-3.2A3.2,3.2,0,0,0,4.074,7.272Z"
                    transform="translate(876.911 7761.174)"
                    fill={FetchCompanyDetails1?.data[0]?.textcolor}
                />
                <path
                    id="Path_2060-2"
                    data-name="Path 2060"
                    d="M23.059,21.965A.863.863,0,0,1,22.2,21.1V19.072a3.2,3.2,0,0,0-2.4-3.093.863.863,0,0,1,.431-1.671,4.924,4.924,0,0,1,3.693,4.764V21.1A.863.863,0,0,1,23.059,21.965Z"
                    transform="translate(872.14 7758.358)"
                    fill={FetchCompanyDetails1?.data[0]?.textcolor}
                />
                <path
                    id="Path_2061-2"
                    data-name="Path 2061"
                    d="M16.012,11.874a.863.863,0,0,1-.213-1.7,3.2,3.2,0,0,0,0-6.2.863.863,0,0,1,.428-1.672,4.924,4.924,0,0,1,0,9.54A.865.865,0,0,1,16.012,11.874Z"
                    transform="translate(872.079 7758.176)"
                    fill={FetchCompanyDetails1?.data[0]?.textcolor}
                />
            </g>
        </svg>
    );
};
export const SVGContacts = () => {
    const FetchCompanyDetails1 = useSelector(
        (state) => state.user.FetchCompanyDetails
    );
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22.525 17.724">
            <g
                id="Group_3057"
                data-name="Group 3057"
                transform="translate(-872 -7827.068)"
            >
                <path
                    id="Line_10"
                    data-name="Line 10"
                    d="M14.817.944H.047a.9.9,0,0,1,0-1.794h14.77a.9.9,0,0,1,0,1.794Z"
                    transform="translate(878.811 7843.374)"
                    fill={FetchCompanyDetails1?.data[0]?.textcolor}
                />
                <path
                    id="Line_8"
                    data-name="Line 8"
                    d="M14.817.944H.047a.9.9,0,0,1,0-1.794h14.77a.9.9,0,0,1,0,1.794Z"
                    transform="translate(878.811 7828.603)"
                    fill={FetchCompanyDetails1?.data[0]?.textcolor}
                />
                <path
                    id="Line_9"
                    data-name="Line 9"
                    d="M14.817.944H.047a.9.9,0,0,1,0-1.794h14.77a.9.9,0,0,1,0,1.794Z"
                    transform="translate(878.811 7835.989)"
                    fill={FetchCompanyDetails1?.data[0]?.textcolor}
                />
                <circle
                    id="Ellipse_11"
                    data-name="Ellipse 11"
                    cx="1.477"
                    cy="1.477"
                    r="1.477"
                    transform="translate(872 7827.068)"
                    fill={FetchCompanyDetails1?.data[0]?.textcolor}
                />
                <circle
                    id="Ellipse_12"
                    data-name="Ellipse 12"
                    cx="1.477"
                    cy="1.477"
                    r="1.477"
                    transform="translate(872 7834.454)"
                    fill={FetchCompanyDetails1?.data[0]?.textcolor}
                />
                <circle
                    id="Ellipse_13"
                    data-name="Ellipse 13"
                    cx="1.477"
                    cy="1.477"
                    r="1.477"
                    transform="translate(872 7841.838)"
                    fill={FetchCompanyDetails1?.data[0]?.textcolor}
                />
                <path
                    id="Line_10-2"
                    data-name="Line 10"
                    d="M14.817.944H.047a.9.9,0,0,1,0-1.794h14.77a.9.9,0,0,1,0,1.794Z"
                    transform="translate(878.811 7843.374)"
                    fill={FetchCompanyDetails1?.data[0]?.textcolor}
                />
                <path
                    id="Line_8-2"
                    data-name="Line 8"
                    d="M14.817.944H.047a.9.9,0,0,1,0-1.794h14.77a.9.9,0,0,1,0,1.794Z"
                    transform="translate(878.811 7828.603)"
                    fill={FetchCompanyDetails1?.data[0]?.textcolor}
                />
                <path
                    id="Line_9-2"
                    data-name="Line 9"
                    d="M14.817.944H.047a.9.9,0,0,1,0-1.794h14.77a.9.9,0,0,1,0,1.794Z"
                    transform="translate(878.811 7835.989)"
                    fill={FetchCompanyDetails1?.data[0]?.textcolor}
                />
                <circle
                    id="Ellipse_11-2"
                    data-name="Ellipse 11"
                    cx="1.477"
                    cy="1.477"
                    r="1.477"
                    transform="translate(872 7827.068)"
                    fill={FetchCompanyDetails1?.data[0]?.textcolor}
                />
                <circle
                    id="Ellipse_12-2"
                    data-name="Ellipse 12"
                    cx="1.477"
                    cy="1.477"
                    r="1.477"
                    transform="translate(872 7834.454)"
                    fill={FetchCompanyDetails1?.data[0]?.textcolor}
                />
                <circle
                    id="Ellipse_13-2"
                    data-name="Ellipse 13"
                    cx="1.477"
                    cy="1.477"
                    r="1.477"
                    transform="translate(872 7841.838)"
                    fill={FetchCompanyDetails1?.data[0]?.textcolor}
                />
            </g>
        </svg>
    );
};
export const SVGPlanBoard = () => {
    const FetchCompanyDetails1 = useSelector(
        (state) => state.user.FetchCompanyDetails
    );
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19.085 19.661">
            <path
                id="Path_2103"
                data-name="Path 2103"
                d="M195.511,105.059h-2.679v-.708a.528.528,0,0,0-1.056,0v.708h-6.707v-.708a.528.528,0,0,0-1.056,0v.708h-2.679a2.206,2.206,0,0,0-2.2,2.2v13.519a2.206,2.206,0,0,0,2.2,2.2H195.51a2.206,2.206,0,0,0,2.2-2.2V107.262a2.206,2.206,0,0,0-2.2-2.2Zm-15.325,2.2a1.148,1.148,0,0,1,1.147-1.147h2.679v.708a.528.528,0,0,0,1.056,0v-.708h6.707v.708h0a.528.528,0,0,0,1.056,0v-.708h2.679a1.148,1.148,0,0,1,1.147,1.147v3.19H180.185Zm15.325,14.668H181.332a1.148,1.148,0,0,1-1.147-1.149V111.5h16.472v9.279a1.148,1.148,0,0,1-1.147,1.149Z"
                transform="translate(-178.879 -103.573)"
                fill={FetchCompanyDetails1?.data[0]?.textcolor}
                stroke="#323232"
                strokeWidth="0.5"
            />
        </svg>
    );
};
export const SVGStock = () => {
    const FetchCompanyDetails1 = useSelector(
        (state) => state.user.FetchCompanyDetails
    );
    return (
        <svg
            id="package"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 18.996 21"
        >
            <g id="Group_2699" data-name="Group 2699">
                <path
                    id="Path_2028"
                    data-name="Path 2028"
                    d="M16.147,10a.816.816,0,0,1-.409-.11l-8.679-5a.82.82,0,0,1,.819-1.42l8.678,5a.82.82,0,0,1-.41,1.53Z"
                    transform="translate(-2.311 -1.231)"
                    fill="#333333"
                />
                <path
                    id="Path_2029"
                    data-name="Path 2029"
                    d="M11.648,22.073a2.752,2.752,0,0,1-1.374-.368L3.527,17.849A2.758,2.758,0,0,1,2.15,15.47V7.755A2.757,2.757,0,0,1,3.524,5.377l6.753-3.859a2.748,2.748,0,0,1,2.745,0l6.747,3.855a2.758,2.758,0,0,1,1.377,2.379V15.47a2.757,2.757,0,0,1-1.374,2.378l-6.753,3.859A2.748,2.748,0,0,1,11.648,22.073Zm0-19.282a1.11,1.11,0,0,0-.554.149L4.341,6.8a1.111,1.111,0,0,0-.551.957V15.47a1.112,1.112,0,0,0,.554.958l6.747,3.855a1.109,1.109,0,0,0,1.112,0l6.753-3.859a1.111,1.111,0,0,0,.551-.957V7.755a1.112,1.112,0,0,0-.554-.958L12.206,2.942A1.114,1.114,0,0,0,11.648,2.791Z"
                    transform="translate(-2.15 -1.152)"
                    fill={FetchCompanyDetails1?.data[0]?.textcolor}
                />
                <path
                    id="Path_2030"
                    data-name="Path 2030"
                    d="M11.658,12.619a.819.819,0,0,1-.41-.11L2.829,7.639A.82.82,0,1,1,3.65,6.22l8.008,4.632L19.666,6.22a.82.82,0,1,1,.821,1.419l-8.418,4.87A.819.819,0,0,1,11.658,12.619Z"
                    transform="translate(-2.16 -1.329)"
                    fill="#333333"
                />
                <path
                    id="Path_2031"
                    data-name="Path 2031"
                    d="M11.97,22.509a.82.82,0,0,1-.82-.82V11.97a.82.82,0,1,1,1.639,0v9.72A.82.82,0,0,1,11.97,22.509Z"
                    transform="translate(-2.471 -1.509)"
                    fill="#333333"
                />
            </g>
        </svg>
    );
};
export const SVGStock2 = () => {
    const FetchCompanyDetails1 = useSelector(
        (state) => state.user.FetchCompanyDetails
    );
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18.996 21">
            <g id="package" transform="translate(-2.15 -1.152)">
                <g
                    id="Group_2699"
                    data-name="Group 2699"
                    transform="translate(2.15 1.152)"
                >
                    <path
                        id="Path_2028"
                        data-name="Path 2028"
                        d="M16.147,10a.816.816,0,0,1-.409-.11l-8.679-5a.82.82,0,0,1,.819-1.42l8.679,5a.82.82,0,0,1-.41,1.53Z"
                        transform="translate(-2.311 -1.231)"
                        fill="#212121"
                    />
                    <path
                        id="Path_2029"
                        data-name="Path 2029"
                        d="M11.648,22.073a2.752,2.752,0,0,1-1.374-.368L3.527,17.849A2.758,2.758,0,0,1,2.15,15.47V7.755A2.757,2.757,0,0,1,3.524,5.377l6.753-3.859a2.748,2.748,0,0,1,2.745,0l6.747,3.855a2.758,2.758,0,0,1,1.377,2.379V15.47a2.757,2.757,0,0,1-1.374,2.378l-6.753,3.859A2.748,2.748,0,0,1,11.648,22.073Zm0-19.282a1.11,1.11,0,0,0-.554.149L4.341,6.8a1.111,1.111,0,0,0-.551.957V15.47a1.112,1.112,0,0,0,.554.958l6.747,3.855a1.109,1.109,0,0,0,1.112,0l6.753-3.859a1.111,1.111,0,0,0,.551-.957V7.755a1.112,1.112,0,0,0-.554-.958L12.206,2.942A1.114,1.114,0,0,0,11.648,2.791Z"
                        transform="translate(-2.15 -1.152)"
                        fill="#212121"
                    />
                    <path
                        id="Path_2030"
                        data-name="Path 2030"
                        d="M11.658,12.619a.819.819,0,0,1-.41-.11L2.829,7.639A.82.82,0,1,1,3.65,6.22l8.008,4.632L19.666,6.22a.82.82,0,1,1,.821,1.419l-8.418,4.87A.819.819,0,0,1,11.658,12.619Z"
                        transform="translate(-2.16 -1.329)"
                        fill="#212121"
                    />
                    <path
                        id="Path_2031"
                        data-name="Path 2031"
                        d="M11.97,22.509a.82.82,0,0,1-.82-.82V11.97a.82.82,0,1,1,1.639,0v9.72A.82.82,0,0,1,11.97,22.509Z"
                        transform="translate(-2.471 -1.509)"
                        fill="#212121"
                    />
                </g>
            </g>
        </svg>
    );
};
export const SVGDocument = () => {
    const FetchCompanyDetails1 = useSelector(
        (state) => state.user.FetchCompanyDetails
    );
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17.746 22.5">
            <path
                id="document"
                d="M5.671,24.878H16.782a3.349,3.349,0,0,0,2.485-.842A3.426,3.426,0,0,0,20.1,21.53V12.052a7.668,7.668,0,0,0-.078-1.189,2.654,2.654,0,0,0-.3-.884,4.122,4.122,0,0,0-.662-.845L13.444,3.428a3.255,3.255,0,0,0-1.235-.844,4.886,4.886,0,0,0-1.543-.205h-5a3.34,3.34,0,0,0-2.48.847,3.431,3.431,0,0,0-.837,2.511V21.53a3.413,3.413,0,0,0,.837,2.506A3.352,3.352,0,0,0,5.671,24.878ZM5.8,23a1.559,1.559,0,0,1-1.168-.4,1.594,1.594,0,0,1-.39-1.157V5.82a1.585,1.585,0,0,1,.4-1.152,1.565,1.565,0,0,1,1.173-.407h4.541v5.878a2.144,2.144,0,0,0,.523,1.578,2.129,2.129,0,0,0,1.568.523h5.787v9.2A1.4,1.4,0,0,1,16.647,23ZM12.64,10.539a.516.516,0,0,1-.6-.6V4.561l5.887,5.978Z"
                transform="translate(-2.354 -2.378)"
                fill={FetchCompanyDetails1?.data[0]?.textcolor}
            />
        </svg>
    );
};

export const SVGSettings = () => {
    const FetchCompanyDetails1 = useSelector(
        (state) => state.user.FetchCompanyDetails
    );
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18.988 18.988">
            <g id="settings" transform="translate(0 0)">
                <g
                    id="Group_2695"
                    data-name="Group 2695"
                    transform="translate(0 0)"
                >
                    <path
                        id="Ellipse_1"
                        data-name="Ellipse 1"
                        d="M2.235-.85A3.085,3.085,0,1,1-.85,2.235,3.088,3.088,0,0,1,2.235-.85Zm0,4.807A1.723,1.723,0,1,0,.512,2.235,1.725,1.725,0,0,0,2.235,3.957Z"
                        transform="translate(7.26 7.26)"
                        fill="#212121"
                    />
                    <path
                        id="Path_2022"
                        data-name="Path 2022"
                        d="M9.708,19.138a2.286,2.286,0,0,1-2.283-2.283v-.063a.637.637,0,0,0-.419-.58l-.04-.016a.641.641,0,0,0-.7.126l-.045.045a2.284,2.284,0,1,1-3.23-3.231l.045-.045a.638.638,0,0,0,.126-.7l0-.007a.641.641,0,0,0-.587-.388H2.433a2.283,2.283,0,0,1,0-4.567H2.5a.637.637,0,0,0,.58-.419q.007-.02.016-.04a.638.638,0,0,0-.126-.7l-.045-.045a2.284,2.284,0,1,1,3.231-3.23L6.2,3.03a.641.641,0,0,0,.7.126.681.681,0,0,1,.157-.048.641.641,0,0,0,.3-.542V2.433a2.283,2.283,0,0,1,4.567,0v.072a.64.64,0,0,0,.388.584l.007,0a.641.641,0,0,0,.7-.126l.045-.045A2.284,2.284,0,1,1,16.3,6.152l-.045.045a.638.638,0,0,0-.126.7.681.681,0,0,1,.048.157.641.641,0,0,0,.542.3h.133a2.283,2.283,0,1,1,0,4.567h-.072a.64.64,0,0,0-.584.388l0,.007a.638.638,0,0,0,.126.7l.045.045a2.284,2.284,0,1,1-3.231,3.23l-.045-.045a.641.641,0,0,0-.7-.126l-.007,0a.641.641,0,0,0-.388.587v.133A2.286,2.286,0,0,1,9.708,19.138ZM7.5,14.941a1.992,1.992,0,0,1,1.291,1.825q0,.008,0,.016v.072a.921.921,0,0,0,1.843,0v-.136a2.012,2.012,0,0,1,3.417-1.432l.005.005.048.048a.922.922,0,1,0,1.3-1.3l-.048-.048-.005-.005a2.014,2.014,0,0,1,1.43-3.417h.075a.921.921,0,0,0,0-1.843h-.136a2,2,0,0,1-1.836-1.214.681.681,0,0,1-.051-.192,1.993,1.993,0,0,1,.454-2.075l.005-.005.048-.048a.922.922,0,1,0-1.3-1.3l-.048.048-.005.005a2.014,2.014,0,0,1-3.417-1.43V2.433a.921.921,0,1,0-1.843,0V2.57A2,2,0,0,1,7.509,4.405a.681.681,0,0,1-.192.051A2,2,0,0,1,5.242,4L5.237,4l-.048-.048a.922.922,0,1,0-1.3,1.3l.048.048.005.005A1.993,1.993,0,0,1,4.347,7.5,1.992,1.992,0,0,1,2.521,8.787H2.433a.921.921,0,1,0,0,1.843H2.57A2.014,2.014,0,0,1,4,14.046L4,14.052l-.048.048a.922.922,0,1,0,1.3,1.3l.048-.048.005-.005a2,2,0,0,1,2.19-.409Z"
                        transform="translate(-0.15 -0.15)"
                        fill={FetchCompanyDetails1?.data[0]?.textcolor}
                    />
                </g>
            </g>
        </svg>
    );
};
export const SVGPlanBoard2 = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19.085 19.661">
            <path
                id="Path_2103"
                data-name="Path 2103"
                d="M195.511,105.059h-2.679v-.708a.528.528,0,0,0-1.056,0v.708h-6.707v-.708a.528.528,0,0,0-1.056,0v.708h-2.679a2.206,2.206,0,0,0-2.2,2.2v13.519a2.206,2.206,0,0,0,2.2,2.2H195.51a2.206,2.206,0,0,0,2.2-2.2V107.262a2.206,2.206,0,0,0-2.2-2.2Zm-15.325,2.2a1.148,1.148,0,0,1,1.147-1.147h2.679v.708a.528.528,0,0,0,1.056,0v-.708h6.707v.708h0a.528.528,0,0,0,1.056,0v-.708h2.679a1.148,1.148,0,0,1,1.147,1.147v3.19H180.185Zm15.325,14.668H181.332a1.148,1.148,0,0,1-1.147-1.149V111.5h16.472v9.279a1.148,1.148,0,0,1-1.147,1.149Z"
                transform="translate(-178.879 -103.573)"
                fill="#95A7C6"
                stroke="#95A7C6"
                strokeWidth="0.5"
            />
        </svg>
    );
};
export const SVGContacts2 = () => {
    const FetchCompanyDetails1 = useSelector(
        (state) => state.user.FetchCompanyDetails
    );
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22.525 17.724">
            <g
                id="Group_3057"
                data-name="Group 3057"
                transform="translate(-872 -7827.068)"
            >
                <path
                    id="Line_10"
                    data-name="Line 10"
                    d="M14.817.944H.047a.9.9,0,0,1,0-1.794h14.77a.9.9,0,0,1,0,1.794Z"
                    transform="translate(878.811 7843.374)"
                    fill="#95A7C6"
                />
                <path
                    id="Line_8"
                    data-name="Line 8"
                    d="M14.817.944H.047a.9.9,0,0,1,0-1.794h14.77a.9.9,0,0,1,0,1.794Z"
                    transform="translate(878.811 7828.603)"
                    fill="#95A7C6"
                />
                <path
                    id="Line_9"
                    data-name="Line 9"
                    d="M14.817.944H.047a.9.9,0,0,1,0-1.794h14.77a.9.9,0,0,1,0,1.794Z"
                    transform="translate(878.811 7835.989)"
                    fill="#95A7C6"
                />
                <circle
                    id="Ellipse_11"
                    data-name="Ellipse 11"
                    cx="1.477"
                    cy="1.477"
                    r="1.477"
                    transform="translate(872 7827.068)"
                    fill="#95A7C6"
                />
                <circle
                    id="Ellipse_12"
                    data-name="Ellipse 12"
                    cx="1.477"
                    cy="1.477"
                    r="1.477"
                    transform="translate(872 7834.454)"
                    fill="#95A7C6"
                />
                <circle
                    id="Ellipse_13"
                    data-name="Ellipse 13"
                    cx="1.477"
                    cy="1.477"
                    r="1.477"
                    transform="translate(872 7841.838)"
                    fill="#95A7C6"
                />
                <path
                    id="Line_10-2"
                    data-name="Line 10"
                    d="M14.817.944H.047a.9.9,0,0,1,0-1.794h14.77a.9.9,0,0,1,0,1.794Z"
                    transform="translate(878.811 7843.374)"
                    fill="#95A7C6"
                />
                <path
                    id="Line_8-2"
                    data-name="Line 8"
                    d="M14.817.944H.047a.9.9,0,0,1,0-1.794h14.77a.9.9,0,0,1,0,1.794Z"
                    transform="translate(878.811 7828.603)"
                    fill="#95A7C6"
                />
                <path
                    id="Line_9-2"
                    data-name="Line 9"
                    d="M14.817.944H.047a.9.9,0,0,1,0-1.794h14.77a.9.9,0,0,1,0,1.794Z"
                    transform="translate(878.811 7835.989)"
                    fill="#95A7C6"
                />
                <circle
                    id="Ellipse_11-2"
                    data-name="Ellipse 11"
                    cx="1.477"
                    cy="1.477"
                    r="1.477"
                    transform="translate(872 7827.068)"
                    fill="#95A7C6"
                />
                <circle
                    id="Ellipse_12-2"
                    data-name="Ellipse 12"
                    cx="1.477"
                    cy="1.477"
                    r="1.477"
                    transform="translate(872 7834.454)"
                    fill="#95A7C6"
                />
                <circle
                    id="Ellipse_13-2"
                    data-name="Ellipse 13"
                    cx="1.477"
                    cy="1.477"
                    r="1.477"
                    transform="translate(872 7841.838)"
                    fill="#95A7C6"
                />
            </g>
        </svg>
    );
};
export const SVGInformation2 = () => {
    return (
        <svg
            id="Group_2719"
            data-name="Group 2719"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 18.918 21.055"
        >
            <path
                id="Path_2062"
                data-name="Path 2062"
                d="M21.159,22.38a.908.908,0,0,1-.908-.908V19.334a3.371,3.371,0,0,0-3.367-3.367H8.334a3.371,3.371,0,0,0-3.367,3.367v2.138a.908.908,0,1,1-1.817,0V19.334A5.19,5.19,0,0,1,8.334,14.15h8.55a5.19,5.19,0,0,1,5.184,5.184v2.138A.908.908,0,0,1,21.159,22.38Z"
                transform="translate(-3.15 -1.324)"
                fill="#95A7C6"
            />
            <path
                id="Ellipse_9"
                data-name="Ellipse 9"
                d="M4.334-.85A5.184,5.184,0,1,1-.85,4.334,5.19,5.19,0,0,1,4.334-.85Zm0,8.55A3.367,3.367,0,1,0,.967,4.334,3.371,3.371,0,0,0,4.334,7.7Z"
                transform="translate(5.125 0.85)"
                fill="#95A7C6"
            />
        </svg>
    );
};
export const SVGSettings2 = () => {
    const FetchCompanyDetails1 = useSelector(
        (state) => state.user.FetchCompanyDetails
    );
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18.988 18.988">
            <g id="settings" transform="translate(0 0)">
                <g
                    id="Group_2695"
                    data-name="Group 2695"
                    transform="translate(0 0)"
                >
                    <path
                        id="Ellipse_1"
                        data-name="Ellipse 1"
                        d="M2.235-.85A3.085,3.085,0,1,1-.85,2.235,3.088,3.088,0,0,1,2.235-.85Zm0,4.807A1.723,1.723,0,1,0,.512,2.235,1.725,1.725,0,0,0,2.235,3.957Z"
                        transform="translate(7.26 7.26)"
                        fill="#95A7C6"
                    />
                    <path
                        id="Path_2022"
                        data-name="Path 2022"
                        d="M9.708,19.138a2.286,2.286,0,0,1-2.283-2.283v-.063a.637.637,0,0,0-.419-.58l-.04-.016a.641.641,0,0,0-.7.126l-.045.045a2.284,2.284,0,1,1-3.23-3.231l.045-.045a.638.638,0,0,0,.126-.7l0-.007a.641.641,0,0,0-.587-.388H2.433a2.283,2.283,0,0,1,0-4.567H2.5a.637.637,0,0,0,.58-.419q.007-.02.016-.04a.638.638,0,0,0-.126-.7l-.045-.045a2.284,2.284,0,1,1,3.231-3.23L6.2,3.03a.641.641,0,0,0,.7.126.681.681,0,0,1,.157-.048.641.641,0,0,0,.3-.542V2.433a2.283,2.283,0,0,1,4.567,0v.072a.64.64,0,0,0,.388.584l.007,0a.641.641,0,0,0,.7-.126l.045-.045A2.284,2.284,0,1,1,16.3,6.152l-.045.045a.638.638,0,0,0-.126.7.681.681,0,0,1,.048.157.641.641,0,0,0,.542.3h.133a2.283,2.283,0,1,1,0,4.567h-.072a.64.64,0,0,0-.584.388l0,.007a.638.638,0,0,0,.126.7l.045.045a2.284,2.284,0,1,1-3.231,3.23l-.045-.045a.641.641,0,0,0-.7-.126l-.007,0a.641.641,0,0,0-.388.587v.133A2.286,2.286,0,0,1,9.708,19.138ZM7.5,14.941a1.992,1.992,0,0,1,1.291,1.825q0,.008,0,.016v.072a.921.921,0,0,0,1.843,0v-.136a2.012,2.012,0,0,1,3.417-1.432l.005.005.048.048a.922.922,0,1,0,1.3-1.3l-.048-.048-.005-.005a2.014,2.014,0,0,1,1.43-3.417h.075a.921.921,0,0,0,0-1.843h-.136a2,2,0,0,1-1.836-1.214.681.681,0,0,1-.051-.192,1.993,1.993,0,0,1,.454-2.075l.005-.005.048-.048a.922.922,0,1,0-1.3-1.3l-.048.048-.005.005a2.014,2.014,0,0,1-3.417-1.43V2.433a.921.921,0,1,0-1.843,0V2.57A2,2,0,0,1,7.509,4.405a.681.681,0,0,1-.192.051A2,2,0,0,1,5.242,4L5.237,4l-.048-.048a.922.922,0,1,0-1.3,1.3l.048.048.005.005A1.993,1.993,0,0,1,4.347,7.5,1.992,1.992,0,0,1,2.521,8.787H2.433a.921.921,0,1,0,0,1.843H2.57A2.014,2.014,0,0,1,4,14.046L4,14.052l-.048.048a.922.922,0,1,0,1.3,1.3l.048-.048.005-.005a2,2,0,0,1,2.19-.409Z"
                        transform="translate(-0.15 -0.15)"
                        fill="#95A7C6"
                    />
                </g>
            </g>
        </svg>
    );
};
export const SVGDocument2 = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17.746 22.5">
            <path
                id="document"
                d="M5.671,24.878H16.782a3.349,3.349,0,0,0,2.485-.842A3.426,3.426,0,0,0,20.1,21.53V12.052a7.668,7.668,0,0,0-.078-1.189,2.654,2.654,0,0,0-.3-.884,4.122,4.122,0,0,0-.662-.845L13.444,3.428a3.255,3.255,0,0,0-1.235-.844,4.886,4.886,0,0,0-1.543-.205h-5a3.34,3.34,0,0,0-2.48.847,3.431,3.431,0,0,0-.837,2.511V21.53a3.413,3.413,0,0,0,.837,2.506A3.352,3.352,0,0,0,5.671,24.878ZM5.8,23a1.559,1.559,0,0,1-1.168-.4,1.594,1.594,0,0,1-.39-1.157V5.82a1.585,1.585,0,0,1,.4-1.152,1.565,1.565,0,0,1,1.173-.407h4.541v5.878a2.144,2.144,0,0,0,.523,1.578,2.129,2.129,0,0,0,1.568.523h5.787v9.2A1.4,1.4,0,0,1,16.647,23ZM12.64,10.539a.516.516,0,0,1-.6-.6V4.561l5.887,5.978Z"
                transform="translate(-2.354 -2.378)"
                fill="#95A7C6"
            />
        </svg>
    );
};

//////////// ASC PROJECT ICON START //////////

export const SVGproject = () => {
    const FetchCompanyDetails1 = useSelector(
        (state) => state.user.FetchCompanyDetails
    );
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 16.341">
            <g id="folder" transform="translate(-1.15 -2.15)">
                <g
                    id="Group_2706"
                    data-name="Group 2706"
                    transform="translate(1.15 2.15)"
                >
                    <path
                        id="Path_2042"
                        data-name="Path 2042"
                        d="M16.786,18.491H3.514A2.367,2.367,0,0,1,1.15,16.127V4.514A2.367,2.367,0,0,1,3.514,2.15H7.662a.705.705,0,0,1,.587.314L9.7,4.638h7.088A2.367,2.367,0,0,1,19.15,7v9.124A2.367,2.367,0,0,1,16.786,18.491ZM3.514,3.56a.955.955,0,0,0-.954.954V16.127a.955.955,0,0,0,.954.954H16.786a.955.955,0,0,0,.954-.954V7a.955.955,0,0,0-.954-.954H9.321a.705.705,0,0,1-.587-.314L7.284,3.56Z"
                        transform="translate(-1.15 -2.15)"
                        fill={FetchCompanyDetails1?.data[0]?.textcolor}
                    />
                </g>
            </g>
        </svg>
    );
};

export const SVGproject2 = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 16.341">
            <g id="folder" transform="translate(-1.15 -2.15)">
                <g
                    id="Group_2706"
                    data-name="Group 2706"
                    transform="translate(1.15 2.15)"
                >
                    <path
                        id="Path_2042"
                        data-name="Path 2042"
                        d="M16.786,18.491H3.514A2.367,2.367,0,0,1,1.15,16.127V4.514A2.367,2.367,0,0,1,3.514,2.15H7.662a.705.705,0,0,1,.587.314L9.7,4.638h7.088A2.367,2.367,0,0,1,19.15,7v9.124A2.367,2.367,0,0,1,16.786,18.491ZM3.514,3.56a.955.955,0,0,0-.954.954V16.127a.955.955,0,0,0,.954.954H16.786a.955.955,0,0,0,.954-.954V7a.955.955,0,0,0-.954-.954H9.321a.705.705,0,0,1-.587-.314L7.284,3.56Z"
                        transform="translate(-1.15 -2.15)"
                        fill="#95A7C6"
                    />
                </g>
            </g>
        </svg>
    );
};
//////////// ASC PROJECT ICON END //////////
export const ChatMoreOptionArrow = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="7.24"
            height="12.231"
            viewBox="0 0 7.24 12.231"
        >
            <path
                id="Up_arrow"
                data-name="Up arrow"
                d="M2.565,12.977a.761.761,0,0,0-.155.227.684.684,0,0,0-.056.281.694.694,0,0,0,.1.36.722.722,0,0,0,.257.257.7.7,0,0,0,.365.1.668.668,0,0,0,.51-.213L8.706,8.746H8l5.116,5.238a.685.685,0,0,0,.516.213A.7.7,0,0,0,14,14.1a.722.722,0,0,0,.257-.257.694.694,0,0,0,.1-.36.679.679,0,0,0-.212-.508L8.893,7.613a.7.7,0,0,0-.247-.182.73.73,0,0,0-.292-.06.739.739,0,0,0-.546.241Z"
                transform="matrix(-0.035, 0.999, -0.999, -0.035, 14.689, -1.857)"
                fill="#333"
            />
        </svg>
    );
};

export const PinChatFillIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="12.563"
            height="12.562"
            viewBox="0 0 12.563 12.562"
        >
            <g id="noun-pin-2107065" transform="translate(-72.934 -72.925)">
                <path
                    id="Union_196"
                    data-name="Union 196"
                    d="M22322.674-180.936a.485.485,0,0,1-.346-.143.49.49,0,0,1-.143-.347.49.49,0,0,1,.143-.347l3.287-3.285-2.166-2.166a.676.676,0,0,1-.2-.529.677.677,0,0,1,.279-.49,3.817,3.817,0,0,1,2.125-.636,3.789,3.789,0,0,1,1.17.186l3.1-2.733a3.341,3.341,0,0,1,.162-1.637.671.671,0,0,1,.486-.422.669.669,0,0,1,.617.181l3.355,3.357a.664.664,0,0,1,.182.615.674.674,0,0,1-.42.486,3.245,3.245,0,0,1-1.137.2,3.307,3.307,0,0,1-.5-.038l-2.732,3.1a3.923,3.923,0,0,1-.449,3.294.668.668,0,0,1-.49.279l-.055,0a.666.666,0,0,1-.473-.2l-2.166-2.165-3.285,3.286A.493.493,0,0,1,22322.674-180.936Z"
                    transform="translate(-22249.252 266.424)"
                    fill="#a5a5a5"
                />
            </g>
        </svg>
    );
};

export const PinChatOutlineIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="12.561"
            height="12.56"
            viewBox="0 0 12.561 12.56"
        >
            <g id="noun-pin-2107065" transform="translate(-72.936 -72.924)">
                <path
                    id="Union_196"
                    data-name="Union 196"
                    d="M22322.326-181.079a.5.5,0,0,1-.139-.348.5.5,0,0,1,.139-.348l3.291-3.285-2.17-2.164a.686.686,0,0,1-.2-.527.716.716,0,0,1,.279-.493,3.86,3.86,0,0,1,2.125-.633,3.79,3.79,0,0,1,1.172.185l3.1-2.735a3.389,3.389,0,0,1,.162-1.637.684.684,0,0,1,.488-.42.673.673,0,0,1,.617.179l3.357,3.358a.661.661,0,0,1,.178.617.68.68,0,0,1-.42.488,3.215,3.215,0,0,1-1.137.2,2.957,2.957,0,0,1-.5-.039l-2.734,3.1a3.921,3.921,0,0,1-.449,3.3.657.657,0,0,1-.492.28h-.051a.665.665,0,0,1-.477-.2l-2.164-2.164-3.285,3.285a.508.508,0,0,1-.348.14A.508.508,0,0,1,22322.326-181.079Zm2.1-6.547,4.443,4.445a2.844,2.844,0,0,0,.057-2.315l-.039-.084.063-.359,3.229-3.666.342-.107.084.022a2.477,2.477,0,0,0,.863.05l-2.584-2.584a2.469,2.469,0,0,0,.051.863l.021.084-.105.342-3.662,3.229-.363.062-.078-.034a2.913,2.913,0,0,0-1.094-.224A2.917,2.917,0,0,0,22324.43-187.626Z"
                    transform="translate(-22249.252 266.424)"
                    fill="#707070"
                />
            </g>
        </svg>
    );
};

export const ArchiveChatOutlineIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="12"
            height="11.044"
            viewBox="0 0 12 11.044"
        >
            <path
                id="Archive"
                d="M5.089,14.824h6.534a1.878,1.878,0,0,0,1.372-.466,1.827,1.827,0,0,0,.475-1.363V6.666H12.4V13.01a.792.792,0,0,1-.209.592.812.812,0,0,1-.594.205H5.109a.811.811,0,0,1-.593-.205.792.792,0,0,1-.209-.592V6.666H3.238v6.329a1.825,1.825,0,0,0,.475,1.366A1.893,1.893,0,0,0,5.089,14.824ZM6.415,9.595H10.3a.439.439,0,0,0,.324-.129.455.455,0,0,0,.129-.336V8.94a.435.435,0,0,0-.452-.458H6.415a.453.453,0,0,0-.33.126.443.443,0,0,0-.129.332v.19a.455.455,0,0,0,.129.336A.446.446,0,0,0,6.415,9.595ZM3.563,7.18H13.15a1.146,1.146,0,0,0,.891-.342,1.311,1.311,0,0,0,.312-.92V5.036a1.3,1.3,0,0,0-.312-.917,1.151,1.151,0,0,0-.891-.339H3.563a1.17,1.17,0,0,0-.882.339,1.264,1.264,0,0,0-.328.917v.883a1.3,1.3,0,0,0,.316.92A1.157,1.157,0,0,0,3.563,7.18ZM3.8,6.186a.413.413,0,0,1-.31-.1.439.439,0,0,1-.093-.31V5.183a.45.45,0,0,1,.093-.316.412.412,0,0,1,.31-.1h9.116a.4.4,0,0,1,.3.1.451.451,0,0,1,.093.316v.594a.44.44,0,0,1-.093.31.4.4,0,0,1-.3.1Z"
                transform="translate(-2.354 -3.78)"
                fill="#707070"
            />
        </svg>
    );
};

export const DeleteChatOutlineIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="12"
            height="13.219"
            viewBox="0 0 12 13.219"
        >
            <defs>
                <clipPath id="clip-path">
                    <rect
                        id="Rectangle_1012"
                        data-name="Rectangle 1012"
                        width="12"
                        height="13.219"
                        fill="#707070"
                    />
                </clipPath>
            </defs>
            <g id="Bin" transform="translate(0 0)">
                <g
                    id="Group_2723"
                    data-name="Group 2723"
                    transform="translate(0 0)"
                    clip-path="url(#clip-path)"
                >
                    <path
                        id="Path_2064"
                        data-name="Path 2064"
                        d="M11.483,2.437H8.954v-.7A1.738,1.738,0,0,0,7.219,0H4.782A1.738,1.738,0,0,0,3.046,1.737v.7H.518a.518.518,0,0,0,0,1.036h.7v8.011A1.738,1.738,0,0,0,2.954,13.22H9.046a1.738,1.738,0,0,0,1.736-1.736V3.473h.7a.518.518,0,0,0,0-1.036m-7.4-.7a.7.7,0,0,1,.7-.7H7.219a.7.7,0,0,1,.7.7v.7H4.081Zm5.666,9.747a.7.7,0,0,1-.7.7H2.954a.7.7,0,0,1-.7-.7V3.473H9.747Z"
                        transform="translate(0 0)"
                        fill="#707070"
                    />
                    <path
                        id="Path_2065"
                        data-name="Path 2065"
                        d="M7.518,9A.518.518,0,0,0,7,9.518v3.656a.518.518,0,0,0,1.036,0V9.518A.518.518,0,0,0,7.518,9"
                        transform="translate(-2.736 -3.518)"
                        fill="#707070"
                    />
                    <path
                        id="Path_2066"
                        data-name="Path 2066"
                        d="M11.518,9A.518.518,0,0,0,11,9.518v3.656a.518.518,0,0,0,1.036,0V9.518A.518.518,0,0,0,11.518,9"
                        transform="translate(-4.299 -3.518)"
                        fill="#707070"
                    />
                </g>
            </g>
        </svg>
    );
};

export const ArchiveBlackOutlineIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="22"
            height="20.247"
            viewBox="0 0 22 20.247"
        >
            <path
                id="Archive"
                d="M7.369,24.027H19.348a3.442,3.442,0,0,0,2.515-.854,3.35,3.35,0,0,0,.87-2.5V9.071H20.774V20.7a1.453,1.453,0,0,1-.383,1.085,1.488,1.488,0,0,1-1.088.376H7.405a1.488,1.488,0,0,1-1.088-.376A1.453,1.453,0,0,1,5.934,20.7V9.071H3.974v11.6a3.347,3.347,0,0,0,.87,2.5A3.471,3.471,0,0,0,7.369,24.027ZM9.8,14.441h7.13a.8.8,0,0,0,.593-.236.833.833,0,0,0,.236-.616V13.24a.8.8,0,0,0-.829-.839H9.8a.83.83,0,0,0-.6.23.812.812,0,0,0-.236.609v.349A.833.833,0,0,0,9.2,14.2.819.819,0,0,0,9.8,14.441ZM4.572,10.014H22.147a2.1,2.1,0,0,0,1.634-.627A2.4,2.4,0,0,0,24.354,7.7V6.082A2.384,2.384,0,0,0,23.781,4.4a2.11,2.11,0,0,0-1.634-.622H4.572A2.144,2.144,0,0,0,2.954,4.4a2.317,2.317,0,0,0-.6,1.681V7.7a2.386,2.386,0,0,0,.58,1.686A2.12,2.12,0,0,0,4.572,10.014ZM5.008,8.19A.756.756,0,0,1,4.44,8.01a.8.8,0,0,1-.171-.568V6.352a.825.825,0,0,1,.171-.579.755.755,0,0,1,.569-.181H21.72a.737.737,0,0,1,.558.181.826.826,0,0,1,.17.579v1.09a.807.807,0,0,1-.17.568.738.738,0,0,1-.558.181Z"
                transform="translate(-2.354 -3.78)"
                fill="#333"
            />
        </svg>
    );
};

export const BackArchiveOutlineIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="22.7"
            height="22.7"
            viewBox="0 0 22.7 22.7"
        >
            <path
                id="Union_165"
                data-name="Union 165"
                d="M1095.323-2414.624a11.279,11.279,0,0,1-3.324-8.026,11.279,11.279,0,0,1,3.324-8.025,11.276,11.276,0,0,1,8.026-3.325,11.276,11.276,0,0,1,8.025,3.325,11.276,11.276,0,0,1,3.325,8.025,11.276,11.276,0,0,1-3.325,8.026,11.275,11.275,0,0,1-8.025,3.324A11.275,11.275,0,0,1,1095.323-2414.624Zm-1.624-8.026a9.661,9.661,0,0,0,9.65,9.65,9.661,9.661,0,0,0,9.65-9.65,9.661,9.661,0,0,0-9.65-9.65A9.661,9.661,0,0,0,1093.7-2422.65Zm8.465,4.469-3.468-3.469-.033-.031a.847.847,0,0,1-.248-.6q0-.011,0-.023s0,0,0-.006,0-.011,0-.016v-.053l0-.013v-.01l0-.012v-.009l0-.012,0-.01,0-.012,0-.009,0-.012,0-.01,0-.011,0-.01,0-.011,0-.01,0-.011,0-.01,0-.011,0-.01,0-.01,0-.01,0-.01,0-.01,0-.009,0-.01,0-.008.005-.011,0-.006a.856.856,0,0,1,.187-.251l3.476-3.476a.849.849,0,0,1,1.2,0,.849.849,0,0,1,0,1.2l-2.049,2.049h6.116a.85.85,0,0,1,.849.85.85.85,0,0,1-.849.85h-6.115l2.048,2.049a.849.849,0,0,1,0,1.2.849.849,0,0,1-.6.249A.848.848,0,0,1,1102.165-2418.181Z"
                transform="translate(-1092 2434)"
                fill="#333"
            />
        </svg>
    );
};

export const XCircleIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="22.7"
            height="22.7"
            viewBox="0 0 22.7 22.7"
        >
            <g id="x-circle" transform="translate(-1.15 -1.149)">
                <g
                    id="Group_2734"
                    data-name="Group 2734"
                    transform="translate(2 2)"
                >
                    <path
                        id="Ellipse_14"
                        data-name="Ellipse 14"
                        d="M10.5-.85A11.35,11.35,0,0,1,21.85,10.5,11.35,11.35,0,0,1,2.474,18.526a11.35,11.35,0,0,1,0-16.051A11.276,11.276,0,0,1,10.5-.85Zm0,21A9.65,9.65,0,1,0,.85,10.5,9.661,9.661,0,0,0,10.5,20.15Z"
                        transform="translate(0 -0.001)"
                        fill="#fafafa"
                    />
                    <path
                        id="Path_2071"
                        data-name="Path 2071"
                        d="M9,16.15A.85.85,0,0,1,8.4,14.7l6.3-6.3a.85.85,0,0,1,1.2,1.2L9.6,15.9A.847.847,0,0,1,9,16.15Z"
                        transform="translate(-1.65 -1.65)"
                        fill="#fafafa"
                    />
                    <path
                        id="Path_2072"
                        data-name="Path 2072"
                        d="M15.3,16.15a.847.847,0,0,1-.6-.249L8.4,9.6A.85.85,0,0,1,9.6,8.4l6.3,6.3a.85.85,0,0,1-.6,1.451Z"
                        transform="translate(-1.65 -1.65)"
                        fill="#fafafa"
                    />
                </g>
            </g>
        </svg>
    );
};

export const RadioButtonIcon = () => {
    return (
        <svg
            id="Radio_Button"
            data-name="Radio Button"
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16"
        >
            <defs>
                <linearGradient
                    id="linear-gradient"
                    x1="0.5"
                    y1="0.019"
                    x2="0.537"
                    y2="1.547"
                    gradientUnits="objectBoundingBox"
                >
                    <stop offset="0" stop-color="#00246a" />
                    <stop offset="1" stop-color="#95a7c6" />
                </linearGradient>
            </defs>
            <rect
                id="Rectangle_1006"
                data-name="Rectangle 1006"
                width="16"
                height="16"
                rx="8"
                fill="url(#linear-gradient)"
            />
        </svg>
    );
};

export const PlusCircle = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 24 24"
            style="fill: rgba(149, 167, 198, 1);transform: ;msFilter:;"
        >
            <path d="M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm5 11h-4v4h-2v-4H7v-2h4V7h2v4h4v2z"></path>
        </svg>
    );
};

export const CrossCircleIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="22.7"
            height="22.7"
            viewBox="0 0 22.7 22.7"
        >
            <g id="x-circle" transform="translate(-1.15 -1.149)">
                <g
                    id="Group_2734"
                    data-name="Group 2734"
                    transform="translate(2 2)"
                >
                    <path
                        id="Ellipse_14"
                        data-name="Ellipse 14"
                        d="M10.5-.85A11.35,11.35,0,0,1,21.85,10.5,11.35,11.35,0,0,1,2.474,18.526a11.35,11.35,0,0,1,0-16.051A11.276,11.276,0,0,1,10.5-.85Zm0,21A9.65,9.65,0,1,0,.85,10.5,9.661,9.661,0,0,0,10.5,20.15Z"
                        transform="translate(0 -0.001)"
                        fill="#a5a5a5"
                    />
                    <path
                        id="Path_2071"
                        data-name="Path 2071"
                        d="M9,16.15A.85.85,0,0,1,8.4,14.7l6.3-6.3a.85.85,0,0,1,1.2,1.2L9.6,15.9A.847.847,0,0,1,9,16.15Z"
                        transform="translate(-1.65 -1.65)"
                        fill="#a5a5a5"
                    />
                    <path
                        id="Path_2072"
                        data-name="Path 2072"
                        d="M15.3,16.15a.847.847,0,0,1-.6-.249L8.4,9.6A.85.85,0,0,1,9.6,8.4l6.3,6.3a.85.85,0,0,1-.6,1.451Z"
                        transform="translate(-1.65 -1.65)"
                        fill="#a5a5a5"
                    />
                </g>
            </g>
        </svg>
    );
};
